import React from 'react';
import {FC, Fragment} from 'react';
import messages from './messages';
import {useFamilyForm} from './use-family-form';
import Icon from '@ailibs/feather-react-ts/dist/Icon';
import AsyncItemPicker from 'components/async-item-picker';
import Button from 'components/button';
import TextInput from 'components/text-input';
import {Trans, useTranslation} from 'react-i18next';
import {Alert, ModalBody, ModalFooter, ModalHeader} from 'reactstrap';

const FamilyForm: FC<Props> = props => {
  const {message, onDismiss} = props;

  const {t} = useTranslation();

  const {submit, params, isLoading, validationErrors, errorMessage, setParams} =
    useFamilyForm();

  const handleKeyboardEventDown = (e: KeyboardEvent) => {
    if (e.code === 'Enter') {
      submit();
    }
  };
  return (
    <Fragment>
      <ModalHeader className="bg-primary" toggle={onDismiss}>
        <span className="text-light">
          <Trans i18nKey={messages.title()} />
        </span>
      </ModalHeader>
      <ModalBody className="">
        <div>
          <TextInput
            onKeyDown={handleKeyboardEventDown}
            onChange={name => setParams({...params, name})}
            value={params.name}
            label={t(...messages.name())}
            errors={validationErrors.name}
          />

          <div className="mb-3">
            <TextInput
              onChange={code => setParams({...params, code})}
              value={params.code}
              onKeyDown={handleKeyboardEventDown}
              label={t(...messages.code())}
              errors={validationErrors.code}
            />
          </div>
          <div className="mb-3">
            <AsyncItemPicker
              endPoint="data/product-collections"
              onChange={c => setParams({...params, collections: c})}
              value={params.collections}
              isMulti
              onKeyDown={handleKeyboardEventDown}
              label={t(...messages.category())}
              errors={validationErrors.product_collections}
            />
          </div>
          <TextInput
            onKeyDown={handleKeyboardEventDown}
            type="textarea"
            rows={5}
            onChange={inspiration => setParams({...params, inspiration})}
            value={params.inspiration}
            label={t(...messages.inspiration())}
            errors={validationErrors.inspiration}
          />

          <div className="row mb-4">
            <div className="col">
              <div>
                {errorMessage && <Alert color="danger">{errorMessage}</Alert>}
              </div>
              <div className="mt-3 d-grid"></div>
            </div>
          </div>
        </div>
      </ModalBody>
      <ModalFooter>
        <Button color="light" onClick={onDismiss}>
          {t('common.cancel')}
        </Button>
        <Button isLoading={isLoading} color="important" onClick={submit}>
          <Icon name="check" size={15} className="me-1" />
          {t('common.saveChanges')}
        </Button>
      </ModalFooter>
    </Fragment>
  );
};

interface Props {
  message?: string;
  onDismiss: () => void;
}

export default FamilyForm;
